<template lang="pug">
#ServiceInfo(v-if="service")
    v-card
        v-card-title {{ p.orgName }}
        v-card-text {{ p.orgAddress }}
</template>

<script>
export default {
    name: 'ServiceInfo',
    props: ['service'],
    data: () => ({}),
    created() {
        window.ServiceInfo = this;
    },
    computed: {
        p() {
            return this.service && this.service.properties;
        },
    },
};
</script>

<style scoped></style>
